import { schema, Schema } from './confirm-reset-password-form.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';

interface Props {
  onSubmit: (payload: Schema) => void;
  isLoading: boolean;
}

export function ConfirmResetPasswordForm({ onSubmit, isLoading }: Props) {
  const { formState, handleSubmit, register } = useForm<Schema>({
    resolver: zodResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input.Group formState={formState} htmlFor="new_password1" label="Nytt lösenord">
        <Input.Field type="password" formState={formState} {...register('new_password1')} />
      </Input.Group>

      <Input.Group formState={formState} htmlFor="new_password2" label="Nytt lösenord (igen)">
        <Input.Field type="password" formState={formState} {...register('new_password2')} />
      </Input.Group>

      <Button.Group align="right">
        <Button type="submit" isLoading={isLoading}>
          Spara lösenord
        </Button>
      </Button.Group>
    </form>
  );
}
